module.exports = __webpack_public_path__ + "media/images/products-img-02-13eccf34fdf413755209b260ce41a471.jpg";